import React, { useContext, useState, useEffect, useCallback } from "react";
import { Flex, Box, Text, Button, Input } from "theme-ui";
import { IoIosAdd, IoIosRemove, IoIosCloseCircle } from "react-icons/io";
import { debounce } from "lodash";
import { CartContext } from "../../../provider/cart-provider";
import styles from "./line-item.style";

const LineItem = (props) => {
  const { item } = props;
  const lineItem = item;
  const lineItemQuantity = item ? item.quantity : 0;
  const [quantity, setQuantity] = useState(lineItemQuantity);
  const productVariant = item.variant;
  const [available, setAvailable] = useState(productVariant.available);
  const {
    updateLineItem,
    removeLineItem,
    store: { client, checkout, updating },
  } = useContext(CartContext);

  const checkAvailability = useCallback(
    (productId) => {
      client.product.fetch(productId).then((fetchedProduct) => {
        // this checks the currently selected variant for availability
        const result =
          fetchedProduct && fetchedProduct.length
            ? fetchedProduct.variants.filter(
                (variant) => variant.id === productVariant.id
              )
            : [];
        if (result && result.length > 0) {
          setAvailable(result[0].available);
        }
      });
    },
    [client.product, productVariant.id]
  );

  useEffect(() => {
    setQuantity(lineItemQuantity);
  }, [lineItemQuantity]);

  useEffect(() => {
    checkAvailability(item.id);
  }, [productVariant, checkAvailability, item.id]);

  // debounce cart update
  const delayedCartUpdate = useCallback(
    debounce(
      // @ts-ignore
      (client, checkout, lineItem, quantity) =>
        updateCart(client, checkout, lineItem, quantity),
      1000
    ),
    []
  );

  const updateCart = (client, checkout, lineItem, quantity = 0) => {
    if (quantity > 0) {
      updateLineItem(client, checkout.id, lineItem.id, quantity);
    } else {
      removeLineItem(client, checkout.id, lineItem.id);
    }
  };

  const handleQuantityChange = (quantity) => {
    if (quantity > 0) {
      setQuantity(quantity);
      delayedCartUpdate(client, checkout, lineItem, quantity);
    } else {
      setQuantity(0);
      delayedCartUpdate(client, checkout, lineItem, quantity);
    }
  };

  const variantImage = item.variant.image ? (
    <img
      src={item.variant.image.src}
      alt={`${item.title} product shot`}
      height="105px"
    />
  ) : null;

  const handleRemove = () => {
    removeLineItem(client, checkout.id, item.id);
  };
  const getPrice = (price) =>
    Intl.NumberFormat(undefined, {
      currency: price.currencyCode,
      minimumFractionDigits: 2,
      style: "currency",
    }).format(parseFloat(price && price.amount ? price.amount : 0));
  return (
    <>
      {quantity ? (
        <Flex sx={styles.wrapper}>
          <Box sx={styles.imageWrapper}>
            {variantImage}
            <Button variant="text" onClick={handleRemove}>
              <IoIosCloseCircle />
            </Button>
          </Box>

          <Box sx={styles.contentWrapper}>
            <Box>
              <Text sx={styles.title}>{item.title}</Text>
              <Text sx={styles.unitPrice}>
                Unit Price {getPrice(item.variant.priceV2)}
              </Text>
            </Box>
            <Box sx={styles.counterWrapper}>
              <Box sx={styles.cartCounter}>
                <Button
                  disabled={!available || updating}
                  onClick={() => handleQuantityChange(quantity - 1)}
                >
                  <IoIosRemove />
                </Button>
                <Input
                  type="number"
                  id="quantity"
                  name="quantity"
                  value={quantity}
                />
                <Button
                  disabled={!available || updating}
                  onClick={() => handleQuantityChange(quantity + 1)}
                >
                  <IoIosAdd />
                </Button>
              </Box>
              <Text sx={styles.totalPrice}>
                {getPrice({
                  amount: (item.variant.priceV2.amount * quantity).toFixed(2),
                  currencyCode: item.variant.priceV2.currencyCode,
                })}
              </Text>
            </Box>
          </Box>
        </Flex>
      ) : null}
    </>
  );
};

export default LineItem;
